import React from 'react'
import { graphql } from 'gatsby'

// Components
import CharityPage from './CharityPage'

const CharityIndex = (props) => {
  // console.log('👾 index > ', props)
  return <CharityPage {...props} />
}

export default CharityIndex

export const charityQuery = graphql`
  query CharityQuery {
    ...SiteConfig
    prismicCharity {
      data {
        body {
          ... on PrismicCharityDataBodyContent {
            slice_type
            primary {
              content {
                raw
              }
            }
          }
          ... on PrismicCharityDataBodyContentWithImage {
            slice_type
            primary {
              content {
                raw
              }
              image {
                alt
                gatsbyImageData(width: 768, imgixParams: { auto: "format, compress" })
              }
            }
          }
          ... on PrismicCharityDataBodyImageInsert3x {
            slice_type
            primary {
              image1 {
                alt
                gatsbyImageData(width: 768, imgixParams: { auto: "format, compress" })
              }
              image2 {
                alt
                gatsbyImageData(width: 768, imgixParams: { auto: "format, compress" })
              }
              image3 {
                alt
                gatsbyImageData(width: 768, imgixParams: { auto: "format, compress" })
              }
            }
          }
        }
        charity_callout {
          amount
          title
        }
        hero {
          content
          title
          type
          label
          link {
            url
            uid
            type
          }
          image {
            alt
            gatsbyImageData(width: 1440, imgixParams: { auto: "format, compress" })
          }
        }
      }
    }
  }
`
